import { apiService } from "./api.service";

// Get compliance config for the current company
export const getComplianceConfig = (clientId) =>
  apiService.post("SAVE_COMPLIANCE", { ClientId: clientId });

// Get last compliance for the current client
export const getLastKioskCompliance = (clientId, application) =>
  apiService.get(
    `KIOSK_COMPLIANCE_LAST?clientId=${clientId}&application=${application}`
  );

// Save compliance acceptance
export const saveKioskCompliance = (clientId, application) =>
  apiService.post("SAVE_COMPLIANCE", {
    clientId,
    application,
    timeStamp: new Date().toISOString(),
  });

// Record compliance agreement
export const recordComplianceAgreement = (clientId, application) =>
  apiService.post("RECORD_COMPLIANCE_AGREEMENT", {
    clientId,
    application,
    timeStamp: new Date().toISOString(),
  });
